import styled from 'styled-components'
import { SwatchesIcon } from '@sainsburys-tech/bolt-icons'

const OrderSwatch = styled.div`
  display: flex;
  cursor: pointer;
`

const OrderSwatchIcon = styled(SwatchesIcon)`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  top: 0;
`

const SpinnerWrapper = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  height: 100%;
`

const IframeContainer = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  height: 100%;

  iframe {
    height: 100%;
    width: 100%;
  }
`

export { OrderSwatch, OrderSwatchIcon, SpinnerWrapper, IframeContainer }
